export const VISIBLE_TOOLS_PER_ROW = 5
